import React from 'react';
import { Helmet } from 'react-helmet-async';
import { BRAND } from '../config/brand';

const KundlistarSchema: React.FC = () => {
  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: BRAND.name,
    alternateName: BRAND.alternateNames,
    url: BRAND.url,
    logo: BRAND.logoUrl,
    description:
      'Kundlistar is an advanced astrology platform for Vedic, KP, Nadi, BNN, Jaimini and personalised astrology analysis.',
    founder: {
      '@type': 'Person',
      name: 'Anmol Chanana',
    },
    sameAs: [
      BRAND.playStoreUrl,
      'https://www.youtube.com/@kundlistar',
      'https://www.instagram.com/kundlistar',
      'https://www.linkedin.com/company/kundlistar',
    ],
  };

  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: BRAND.name,
    alternateName: 'Kundlistar',
    url: BRAND.url,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${BRAND.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const softwareSchema = {
    '@context': 'https://schema.org',
    '@type': 'SoftwareApplication',
    name: BRAND.name,
    alternateName: BRAND.alternateNames,
    applicationCategory: 'LifestyleApplication',
    applicationSubCategory: 'Astrology Software',
    operatingSystem: 'Web, Android, iOS, iPadOS',
    url: BRAND.url,
    downloadUrl: BRAND.playStoreUrl,
    image: BRAND.logoUrl,
    description:
      'Kundlistar is an astrology software platform for Vedic, KP, Nadi, BNN, Jaimini, Numerology, Panchang, Mahurat, Lal Kitaab, Tajika Varshphal, Astro Vastu and personalised Gochar analysis.',
    featureList: [
      'Vedic astrology chart generation',
      'KP astrology cusps, sub lords and ruling planets',
      'Nadi and BNN life event analysis',
      'Jaimini analysis',
      'Numerology reports',
      'Panchang, Mahurat, Choghadiya and Panch Pakshi',
      'South Indian and East Indian chart styles',
      'Ashtakavarga, Shadbala and divisional charts',
      'Premium AI-based astrology reports',
    ],
    offers: {
      '@type': 'Offer',
      price: '999',
      priceCurrency: 'INR',
      availability: 'https://schema.org/InStock',
      url: `${BRAND.url}/pricing`,
      description: 'Yearly Premium plan at INR 999 per year.',
    },
  };

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: `${BRAND.name} Premium`,
    alternateName: BRAND.alternateNames,
    brand: {
      '@type': 'Brand',
      name: BRAND.name,
    },
    category: 'Astrology software',
    image: BRAND.logoUrl,
    description:
      'Kundlistar Premium unlocks advanced astrology modules, PDF reports, AI-based reports, saved charts and professional Jyotish workflows.',
    offers: {
      '@type': 'Offer',
      price: '999',
      priceCurrency: 'INR',
      url: `${BRAND.url}/pricing`,
      availability: 'https://schema.org/InStock',
    },
    review: {
      '@type': 'Review',
      author: {
        '@type': 'Organization',
        name: BRAND.name,
      },
      reviewBody:
        'Kundlistar is built as an all-in-one astrology platform for astrologers, astrology students and serious learners who need Vedic, KP, Nadi, BNN, Jaimini, Numerology and Panchang workflows in one place.',
    },
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(softwareSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(productSchema)}</script>
    </Helmet>
  );
};

export default KundlistarSchema;
